import z from 'zod';

import { billingStatusLabel } from './superadminBillingDisplay';

import type { ListSuperadminOrganizationsBillingStatus } from '../../../api';

export const RecordStatusSchema = z.enum(['all', 'active', 'archived']);
export type SuperadminOrganizationsRecordStatusFilter = z.infer<typeof RecordStatusSchema>;

export const RECORD_STATUS_FILTER_OPTIONS: { value: z.infer<typeof RecordStatusSchema>; label: string }[] =
  [
    { value: 'all', label: 'All' },
    { value: 'active', label: 'Active' },
    { value: 'archived', label: 'Archived' },
  ];

export const OrganizationsSearchParamsSchema = z.object({
  search: z.string().optional(),
  recordStatus: RecordStatusSchema.optional(),
  sortBy: z.enum(['name', 'members', 'created']).optional(),
  sortDirection: z.enum(['asc', 'desc']).optional(),
  billingStatus: z
    .enum(['none', 'trialing', 'active', 'past_due', 'suspended', 'cancelled'])
    .optional(),
});

export const SUBSCRIPTION_FILTER_OPTIONS: {
  value: ListSuperadminOrganizationsBillingStatus;
  label: string;
}[] = [
  { value: 'none', label: 'No billing record' },
  { value: 'trialing', label: billingStatusLabel('trialing') },
  { value: 'active', label: billingStatusLabel('active') },
  { value: 'past_due', label: billingStatusLabel('past_due') },
  { value: 'suspended', label: billingStatusLabel('suspended') },
  { value: 'cancelled', label: billingStatusLabel('cancelled') },
];
